<template>
  <modal size="md" content-class="p-sm-4" @close="close">
    <template #header>
      <h5 class="mb-0">Card Payment</h5>
    </template>

    <template #body>
      <p v-if="amount" class="text-center mb-3">
        Amount to pay: <strong>${{ amount }}</strong>
      </p>
      <label class="d-block mb-1 small text-muted">Card details</label>
      <div ref="cardEl" class="form-control stripe-card-modal__element" />
      <div v-if="errorMessage" class="text-danger small mt-2">{{ errorMessage }}</div>
    </template>

    <template #footer>
      <app-button variant="outline-primary" :disabled="submitting" @click="close">Cancel</app-button>
      <app-button :loading="submitting" :disabled="!ready" @click="submit">Pay Now</app-button>
    </template>
  </modal>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeUnmount, getCurrentInstance } from '@vue/composition-api'
import { loadStripe } from '@stripe/stripe-js'
import Modal from '@/components/Modal'
import AppButton from '@/components/AppButton'

export default defineComponent({
  name: 'StripeCardModal',
  components: { Modal, AppButton },
  props: {
    amount: { type: String, default: '' }
  },
  emits: ['token', 'close'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const cardEl = ref(null)
    const ready = ref(false)
    const submitting = ref(false)
    const errorMessage = ref('')
    let stripe = null
    let card = null

    onMounted(async () => {
      try {
        stripe = await loadStripe(proxy.$stripePk)
        const elements = stripe.elements()
        card = elements.create('card', { hidePostalCode: true })
        card.mount(cardEl.value)
        card.on('change', (event) => {
          errorMessage.value = event.error != null ? event.error.message : ''
        })
        ready.value = true
      } catch (_err) {
        errorMessage.value = 'Unable to load the payment form. Please try again.'
      }
    })

    onBeforeUnmount(() => {
      if (card != null) card.destroy()
    })

    async function submit() {
      if (stripe == null || card == null || submitting.value) return
      submitting.value = true
      errorMessage.value = ''
      try {
        const result = await stripe.createToken(card)
        if (result.error != null) {
          errorMessage.value = result.error.message
          return
        }
        emit('token', result.token)
      } catch (_err) {
        errorMessage.value = 'The card could not be processed. Please try again.'
      } finally {
        submitting.value = false
      }
    }

    function close(event) {
      if (event != null && typeof event.preventDefault === 'function') {
        event.preventDefault()
      }
      if (submitting.value) return
      emit('close')
    }

    return {
      cardEl,
      ready,
      submitting,
      errorMessage,
      submit,
      close
    }
  }
})
</script>

<style scoped>
.stripe-card-modal__element {
  height: auto;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/StripeCardModal.vue